@let indirizziConfermati = (indirizziConfermati$ | async);

<div class="card card-w-title">
  <h1>Gestione Soggetti provvisori</h1>
  @if ( indirizziConfermati) {
    <app-gestione-indirizzi-provvisori [indirizziConfermati]="indirizziConfermati"></app-gestione-indirizzi-provvisori>
  }
</div>
<div class="card card-w-title">
  <h1>Gestione Soggetti</h1>
  <app-soggetto-editor
    [itemTitle]="'Soggetto'"
    [nameProperty]="'nomeIndirizzo'"
    [filterRows]="filterConfermati"
    (add)="openSoggettoDialog()">
  </app-soggetto-editor>
  <button *ngIf="indirizziConfermati" pButton class="topButton" type="button"
    icon="fas fa-print" label="Stampa" title="Stampa" (click)="printIndirizzi(indirizziConfermati)"></button>
</div>

<app-soggetto-dialog></app-soggetto-dialog>

<p-toast key="toast" position="top-center"></p-toast>
